import { Component, Inject, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { HLong } from '@shared/src/datatypes/HLong';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { PackageInRouteDto } from '@shared/src/dtos/shipment/delivery/PackageInRouteDto';
import { OrderPackageInRouteDto, OrderPackagesInRouteDto } from '@shared/src/dtos/shipment/OrderPackagesInRouteDto';
import { PackageController } from '@shared/src/controllers/route/delivery/package.controller';

@Component({
    selector: 'shared-route-package-order',
    templateUrl: './shared.route.package.order.component.html',
    styleUrls: ['./shared.route.package.order.component.scss']
})
export class SharedRoutePackageOrderComponent implements OnInit {

    constructor(public openRouteController: OpenRouteController, @Inject('HomeController') public homeController: HomeController,
        @Inject('SecurityController') public securityController: SecurityController, private packageController: PackageController) {
        this.securityController.getStoredUserDto().subscribe(data => {
            this.readonly = data.isReadOnly;
        });

    }

    @Output()
    public valueChange: EventEmitter<boolean> = new EventEmitter();

    @Input()
    public readonly: boolean = false;

    @Input()
    public onlyvieworder: boolean = false;

    public _routeId: number;
    @Input()
    set routeId(value: number) {
        if (this._routeId === value)
            return;

        this._routeId = value;

        this.loadData();
    }
    get routeId(): number {
        return this._routeId;
    }


    ngOnInit() {
        this.loadOptionsOrder();
    }

    public optionsOrder: OptionsStripDto;
    public actualOptionOrderId: string = "PACKAGE";
    public loadOptionsOrder() {

        let result = new OptionsStripDto();
        result.add(OptionDto.build("ORDERLOAD", "SHARED.ROUTE.SHIPMENT.OPCIONS.ORDERLOAD.CAPTION", "SHARED.ROUTE.SHIPMENT.OPCIONS.ORDERLOAD.HELP", "", 1, -1, 1, true, false));
        result.add(OptionDto.build("ORDERUNLOAD", "SHARED.ROUTE.SHIPMENT.OPCIONS.ORDERUNLOAD.CAPTION", "SHARED.ROUTE.SHIPMENT.OPCIONS.ORDERUNLOAD.HELP", "", 2, -1, 1, false, false));
        this.actualOptionOrderId = result.getActualSelected().optionId;
        this.optionsOrder = result;
    }

    onClickOptionOrder(option: OptionDto) {
        this.actualOptionOrderId = option.optionId;

    }

    getOrder() {

        if (this.actualOptionOrderId == 'ORDERUNLOAD')
            return '-orderInRoute';

        return 'orderInRoute';
    }

    drop(event: CdkDragDrop<PackageInRouteDto>) {
        moveItemInArray(this.packagesInRoute, event.previousIndex, event.currentIndex);

        let packageInRouteNewOrden: Array<OrderPackageInRouteDto>;

        if (this.actualOptionOrderId == 'ORDERLOAD') {
            packageInRouteNewOrden = this.packagesInRoute.map((item, index) => ({
                routeId: this.routeId,
                packageId: item.packageId,
                orderInRoute: index
            }));
        } else {
            packageInRouteNewOrden = this.packagesInRoute.slice().reverse().map((item, index) => ({
                routeId: this.routeId,
                packageId: item.packageId,
                orderInRoute: index
            }));
        }

        let packagesInRouteNewOrden: OrderPackagesInRouteDto = OrderPackagesInRouteDto.build(this.routeId, packageInRouteNewOrden);
        
        this.packageController.aplicarOrdrePackageInRoute(packagesInRouteNewOrden).subscribe(e => {
            this.loadData();
            if (e) {
                this.valueChange.next(true);
            }
        });
    }


    public showvieworder: boolean;
    public packagesInRoute: PackageInRouteDto[];

    public loadData() {

        if (HLong.isNullOrNullLong(this.routeId)) {
            this.packagesInRoute = new Array();
            return;
        }

        this.packageController.getPackagesInRouteByRouteId(this.routeId).subscribe(data => {
            if (data)
                this.packagesInRoute = data;
            else
                this.packagesInRoute = new Array();

        });

    }

    public selectedPackage: PackageInRouteDto = null;

    selectPackage(packag: PackageInRouteDto) {
        this.selectedPackage = packag;
    }


    movePackageUp(value: PackageInRouteDto) {
        if (!value)
            return;

        //Si estem veien la vista de descarrega, l'acció serà l'inversa
        if (this.actualOptionOrderId == 'ORDERUNLOAD') {
            this.internalMovePackageDown(value);
            return;
        }

        this.internalMovePackageUp(value);
    }

    internalMovePackageUp(value: PackageInRouteDto) {
        if (!value)
            return;

        this.packageController.pujarPackageInRoute(this.routeId, value.packageId).subscribe(e => {
            if (e) {
                this.loadData();
                this.valueChange.next(true);
            }
        });
    }

    movePackageDown(value: PackageInRouteDto) {
        if (!value)
            return;

        //Si estem veien la vista de descarrega, l'acció serà l'inversa
        if (this.actualOptionOrderId == 'ORDERUNLOAD') {
            this.internalMovePackageUp(value);
            return;
        }

        this.internalMovePackageDown(value);
    }

    internalMovePackageDown(value: PackageInRouteDto) {
        if (!value)
            return;

        this.packageController.baixarPackageInRoute(this.routeId, value.packageId).subscribe(e => {
            if (e) {
                this.loadData();
                this.valueChange.next(true);
            }
        });
    }
}
